import { TLC_CONSTANTS } from "../../../js/lib/tlc-constants";
import { TLCEventManager } from "../../../js/lib/events/EventManager";
import { TLCLogger } from "../../../js/lib/logger";

export const HistoryManager = (function ( $, global ) {

	var historyHash = [];
	var myInternalHash = "";

	const getCurrentHash = () => {
		return new URLSearchParams(window.location.hash.substring(1)).toString();
	}

	var hashCheck = function () {
		setTimeout( function () {
			const currentHash = getCurrentHash();
			// var currentHash = decodeURIComponent( global.location.hash.substring( 1 ) );
			if( myInternalHash != currentHash ) {
				TLCLogger.log( "HistoryManager:currentHash", currentHash );
				myInternalHash = currentHash;
				var foundHistory = false;
				$.each( historyHash, function ( index, historyItem ) {
					if( historyItem.uniqueHashValue == myInternalHash ) {
						handleChange( historyItem, true );
						foundHistory = true;
						return false;
					}
				} );
				if( !foundHistory ) {
					TLCEventManager.fireEvent( TLC_CONSTANTS.Events.noHistoryFound );
				}
			}
			hashCheck();
		}, 200 );
	};


	var handleChange = function ( historyItem, fireCallback ) {
		if( historyItem ) {
			//if(changeHash) {
			myInternalHash = historyItem.uniqueHashValue;
			global.location.hash = myInternalHash;
			//}
			if( fireCallback ) {
				if( historyItem.data ) {
					historyItem.data = $.extend( {}, historyItem.data, {fromHistory: true} );
				}
				historyItem.callback( historyItem.data, historyItem.uniqueHashValue );
			}

		}

	};

	hashCheck();

	return {
		goBack:    function ( numToGoBack ) {
			numToGoBack = numToGoBack || 1;
			handleChange( historyHash[(historyHash.length - 1) - numToGoBack], true );
		},
		goForward: function ( numToGoForward ) {
			numToGoForward = numToGoForward || 1;
		},
		add:       function ( hashValue, callback, data ) {
			var currentIndex = historyHash.length,
				uniqueHashValue = hashValue;// + "|" + currentIndex;

			historyHash.push( {
				uniqueHashValue: uniqueHashValue,
				callback:        callback,
				data:            data
			} );

			const currentHash = getCurrentHash();

			if(currentHash !== hashValue){
				handleChange( historyHash[currentIndex], false );
			}
			return uniqueHashValue;
		},
		clear:     function () {
			historyHash = [];
			myInternalHash = "";
			handleChange( {uniqueHashValue: ""}, false );
		}
	};

})( jQuery, window );
